import React from "react";
import { Navigate } from "react-router-dom";
import { rememberAskNexusOpen } from "./askNexusStore";

/** /virtual-manager: the assistant is a panel now, opened over Home. */
const AskNexusRedirect = () => {
  rememberAskNexusOpen(true);
  return <Navigate to="/dashboard" replace />;
};

export default AskNexusRedirect;
